import { Box, Typography, Button } from "@mui/material";
import { motion } from "motion/react";
import { fadeInOut } from "~/lib/animations";
import { GreenCheckCircleIcon } from "~/components/GreenCheckCircleIcon";

interface HostedIntegrationDropzoneSuccessProps {
  handleDropzoneRefresh: () => void;
  isUpdateFlow: boolean;
}

export const HostedIntegrationDropzoneSuccess = ({
  handleDropzoneRefresh,
  isUpdateFlow,
}: HostedIntegrationDropzoneSuccessProps) => {
  return (
    <Box
      component={motion.div}
      {...fadeInOut}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 5,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6">Successfully loaded certificate</Typography>
        <GreenCheckCircleIcon fontSize="large" sx={{ ml: 2 }} />
      </Box>

      <Button
        variant="outlined"
        color="secondary"
        onClick={handleDropzoneRefresh}
      >
        {isUpdateFlow ? "Refresh certificate" : "Remove certificate"}
      </Button>
    </Box>
  );
};
